(function () {
    'use strict';

    angular
        .module('Lavpop-store.constants', []);

    angular
        .module('Lavpop-store.components', []);

    angular
        .module('Lavpop-store.directives', []);

    angular
        .module('Lavpop-store.filters', []);

    angular
        .module('Lavpop-store.interceptors', []);

    angular
        .module('Lavpop-store.routes', []);

    angular
        .module('Lavpop-store.services', []);
}());